import { useMemo } from 'react';
import { useGetSubscriptionPlansQuery } from 'src/store/services';
import { useGetUser } from 'src/hooks';
import { PriceDiscountType } from 'src/types/wallet/models/PriceDiscountType';
import { PlanFamily, TeamGroup } from 'src/types';
import { getReferralId } from 'src/utils';

type UseSubscriptionPlansProps = {
  group?: TeamGroup;
  seat_count?: number | null;
  families?: PlanFamily[];
  skip?: boolean;
  discountType?: PriceDiscountType;
};

export const useSubscriptionPlans = ({
  group,
  seat_count,
  families = [PlanFamily.PRO, PlanFamily.MAX, PlanFamily.BUSINESS],
  skip,
  discountType,
}: UseSubscriptionPlansProps) => {
  const { user_id, isEnterpriseTier } = useGetUser();
  const referralId = getReferralId();

  const { data, isLoading, isFetching } = useGetSubscriptionPlansQuery(
    {
      user_id: user_id,
      group,
      referral_id: referralId && group !== 'teams' ? referralId : undefined,
      seat_count,
      families,
      discount_type: discountType,
    },
    { skip: isEnterpriseTier || skip },
  );

  return useMemo(() => {
    return {
      plans: data,
      isPlansLoading: isLoading || isFetching,
      // TODO: check if we can just delete isFetching from isPlansLoading
      isPlansLoadingFirstTime: isLoading,
    };
  }, [data, isLoading, isFetching]);
};
